import React from "react";
import CalendarDayButton from "../../UI/CalendarDayButton/CalendarDayButton";
import CalendarHourButton from "../../UI/CalendarHourButton/CalendarHourButton";
import CssClasses from "./Calendar.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import * as PickerIDs from "../../../HOCs/Constants/PickerID";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

let _props = null;

function GetDates(startDate, daysToAdd) {
  var aryDates = [];

  for (var i = 0; i <= daysToAdd; i++) {
    var currentDate = new Date();
    currentDate.setDate(startDate.getDate() + i);
    aryDates.push({
      date: currentDate,
      dayNumber: currentDate.getDate(),
      dayName: DayAsString(currentDate.getDay())
    });
  }

  return aryDates;
}

function DayAsString(dayIndex) {
  var weekdays = new Array(7);
  weekdays[0] = "NED";
  weekdays[1] = "PON";
  weekdays[2] = "UTO";
  weekdays[3] = "SRI";
  weekdays[4] = "ČET";
  weekdays[5] = "PET";
  weekdays[6] = "SUB";

  return weekdays[dayIndex];
}

const Calendar = props => {
  _props = props;

  let calendarInfo = [
    {
      id: 1,
      isBigText: true,
      bigText: "Danas"
    }
  ];

  const hoursInfo = [
    {
      id: 10,
      amount: 3
    },
    {
      id: 11,
      amount: 6
    },
    {
      id: 12,
      amount: 12
    }
  ];

  let markupDays = "";

  calendarInfo[0].date = new Date();

  var startDate = new Date();
  startDate.setDate(startDate.getDate() + 1);
  var nextDays = GetDates(startDate, 0);

  //popuni state
  for (let i = 0; i < nextDays.length; i++) {
    const day = nextDays[i];

    calendarInfo.push({
      id: i + 2,
      dayName: day.dayName,
      dayNumber: day.dayNumber,
      date: day.date,
      isBigText: false
    });
  }

  //i jos stavi all
  calendarInfo.push({
    id: 9,
    isBigText: true,
    bigText: "Sve",
    date: new Date(2014, 0, 1, 12, 0, 0, 0) //1.1.2014, mj je off by 1 tako da je january == 0
  });

  return (
    <div className={CssClasses.container}>
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>
      {/* days section */}
      {calendarInfo.map(day => {
        if (day.isBigText) {
          markupDays = (
            <CalendarDayButton
              onButtonClicked={calendarItemButtonClick}
              id={day.id}
              key={day.id}
              bigText={day.bigText}
              isBigText={true}
              isActive={day.id === props.activeCalendarItemID}
              date={day.date}
            />
          );
        } else {
          markupDays = (
            <CalendarDayButton
              onButtonClicked={calendarItemButtonClick}
              id={day.id}
              key={day.id}
              dayNumber={day.dayNumber}
              dayLabel={day.dayName}
              isActive={day.id === props.activeCalendarItemID}
              date={day.date}
            />
          );
        }

        return markupDays;
      })}

      {/* separator */}
      <hr className={CssClasses.separator} />

      {/* hours section */}
      {hoursInfo.map(hour => {
        return (
          <CalendarHourButton
            onButtonClicked={calendarItemButtonClick}
            hour={hour.amount}
            key={hour.id}
            id={hour.id}
            isActive={hour.id === props.activeCalendarItemID}
          />
        );
      })}
    </div>
  );
};

const calendarItemButtonClick = (id, date) => {
  console.log("Calendar click.." + id + " for date " + date);

  _props.onChangeLastUsedPicker(PickerIDs.CALENDAR);
  _props.onChangeCalendarItem(id, date);

  if (id === 9) {
    //sve, odznaci sve sportove ako su oznaceni
    if (_props.currentSportID === -10) {
      _props.onChangeSportPrematch(2); //stavi na fudbol default
    }
  }

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  //gasi akcije terminala
  _props.setTerminalActionsActiveButton(0);
};

const mapStateToProps = state => {
  return {
    activeCalendarItemID: state.rrNavigation.calendarItemID,
    currentSportID: state.rrNavigation.prematchSportID,
    chosenDate: state.rrNavigation.chosenDate
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeCalendarItem: (calendarItemID, date) =>
      dispatch(StoreActions.ChangeCalendarItem(calendarItemID, date)),
    onChangeSportPrematch: sportID =>
      dispatch(StoreActions.ChangeSportPrematch(sportID)),
    onChangeLastUsedPicker: pickerID =>
      dispatch(StoreActions.ChangeLastUsedPicker(pickerID)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Calendar);



// WEBPACK FOOTER //
// ./src/Components/Navigation/Calendar/Calendar.js